export const diseases_allergy_kids_eng = [
    {
      label: 'Asthma',
      label_show: 'Asthma',
        page: 13,
        Xpos_image: '360px',
        Ypos_image: '480px',
        Xlabel: '378px',
        Ylabel: '565px',
        width: '79px',
        height: 'auto',
        result_comp: [
          { min: 1, max: 3, image: 'asthma_0' },
          { min: 4, max: 6, image: 'asthma_1' },
          { min: 7, max: 10, image: 'asthma_2' }
        ]
    },
    {
      label: 'Eczema',
      label_show: 'Eczema',
      page: 13,
      Xpos_image: '230px',
      Ypos_image: '480px',
      Xlabel: '247px',
      Ylabel: '565px',
      width: '79px',
      height: 'auto',
      result_comp: [
        { min: 1, max: 3, image: 'eczema_0' },
        { min: 4, max: 6, image: 'eczema_1' },
        { min: 7, max: 10, image: 'eczema_2' }
    ]
    },
    {
        label: 'Food allergy',
        label_show: 'Food Allergy',
        page: 13,
        Xpos_image: '490px',
        Ypos_image: '480px',
        Xlabel: '495px',
        Ylabel: '565px',
        width: '79px',
        height: 'auto',
        result_comp: [
          { min: 1, max: 3, image: 'foodallergy_0' },
          { min: 4, max: 6, image: 'foodallergy_1' },
          { min: 7, max: 10, image: 'foodallergy_2' }
        ]
    },    
]

export const diseases_allergy_kids_thai = [
    {
      label: 'Asthma',
      label_show: 'หอบหืด',
      page: 12,
      Xpos_image: '230px',
      Ypos_image: '480px',
      Xlabel: '250px',
      Ylabel: '565px',
      width: '79px',
      height: 'auto',
      result_comp: [
          { min: 1, max: 3, image: 'asthma_0' },
          { min: 4, max: 6, image: 'asthma_1' },
          { min: 7, max: 10, image: 'asthma_2' }
      ]
  },
  {
    label: 'Eczema',
    label_show: 'ภูมิแพ้ผิวหนังอักเสบ',
    page: 12,
    Xpos_image: '360px',
    Ypos_image: '480px',
    Xlabel: '350px',
    Ylabel: '565px',
    width: '79px',
    height: 'auto',
    result_comp: [
      { min: 1, max: 3, image: 'eczema_0' },
      { min: 4, max: 6, image: 'eczema_1' },
      { min: 7, max: 10, image: 'eczema_2' }
    ]
  },
  {
      label: 'Food allergy',
      label_show: 'ภูมิแพ้อาหาร',
      page: 12,
      Xpos_image: '490px',
      Ypos_image: '480px',
      Xlabel: '500px',
      Ylabel: '565px',
      width: '79px',
      height: 'auto',
      result_comp: [
        { min: 1, max: 3, image: 'foodallergy_0' },
        { min: 4, max: 6, image: 'foodallergy_1' },
        { min: 7, max: 10, image: 'foodallergy_2' }
      ]
  },  
]

export const diseases_image_allergy_kids_eng = [
  // {
  //   label: 'Eczema',
  //   label_show: 'Eczema',
  //   page: 12,
  //   Xpos_image: '77px',
  //   Ypos_image: '685px',
  //   Xlabel: '90px',
  //   Ylabel: '757px',
  //   width: '70px',
  //   height: 'auto'
  // },
];

export const diseases_image_allergy_kids_thai = [
  // {
  //   label: 'Eczema',
  //   label_show: 'Eczema',
  //   page: 12,
  //   Xpos_image: '77px',
  //   Ypos_image: '685px',
  //   Xlabel: '90px',
  //   Ylabel: '757px',
  //   width: '70px',
  //   height: 'auto'
  // },
];